<template>
    <button type="button" :title="title" class="btn btn-sm btn-clean btn-icon" :class="[hover]">
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        title: String,
        hover: {
            type: String,
            default: 'btn-hover-light-primary',
        },
    },
}
</script>
